import {Action} from "@ngrx/store";

export const LOAD_JOB: string = '[job] Load Job';
export const LOAD_JOB_SUCCESS: string = '[job] Load Job success';
export const LOAD_JOB_FAIL: string = '[job] Load Job Fail';


export class LoadJob implements Action {

  readonly type: string = LOAD_JOB;
  constructor(public payload: number) {}

}

export class LoadJobSuccess implements Action {

  readonly type: string = LOAD_JOB_SUCCESS;
  constructor(public payload: {
    [id: string]: any
  }) {}

}

export class LoadJobFail implements Action {

  readonly type: string = LOAD_JOB_FAIL;
  constructor(public payload: string) {}

}


export type JobAction = LoadJob | LoadJobSuccess | LoadJobFail;
